export default {
  SET_PACKAGES(state, packages) {
    state.packages = packages
  },
}
